module.exports = __webpack_public_path__ + "img/menu-01.835cf3c4.svg";